// Textos de la interfaz (guía 8: español, con la estructura lista para otros idiomas).
// Para traducir: crear otro archivo con las mismas claves y elegirlo en i18n/index.ts.

export const es = {
  'app.nombre': 'SIT 365',
  'app.lema': 'Departamento de IT · Grupo Siuma y Colliers CAAC',
  'app.area': 'Departamento de IT',
  'comun.guardar': 'Guardar',
  'comun.cancelar': 'Cancelar',
  'comun.continuar': 'Continuar',
  'comun.volver': 'Volver',
  'comun.cargando': 'Cargando…',
  'comun.error_inesperado': 'Ocurrió un error inesperado. Intente de nuevo.',
  'comun.proximamente': 'Próximamente',

  'login.titulo': 'Iniciar sesión',
  'login.descripcion': 'Tickets, proyectos, tareas, usuarios y licencias del Departamento de IT en un solo lugar.',
  'login.correo': 'Correo',
  'login.clave': 'Contraseña',
  'login.entrar': 'Entrar',
  'login.demasiados_intentos': 'Demasiados intentos. Espere un minuto e intente de nuevo.',
  'login.sesion_vencida': 'Su sesión venció. Inicie sesión de nuevo.',
  'login.olvido': '¿Olvidó su contraseña?',

  'clave.recuperar_titulo': 'Recuperar contraseña',
  'clave.recuperar_instruccion': 'Ingrese su correo. Si tiene una cuenta, le enviaremos un enlace para elegir una contraseña nueva.',
  'clave.recuperar_enviar': 'Enviar enlace',
  'clave.recuperar_enviado':
    'Si el correo corresponde a una cuenta, en unos minutos recibirá un enlace. Vence en 30 minutos y sirve una sola vez. Revise también la carpeta de correo no deseado.',
  'clave.restablecer_titulo': 'Elegir una contraseña nueva',
  'clave.nueva': 'Contraseña nueva',
  'clave.confirmar': 'Repita la contraseña nueva',
  'clave.actual': 'Contraseña actual',
  'clave.politica': 'Al menos 12 caracteres. Una frase larga es más segura y fácil de recordar que una palabra con símbolos.',
  'clave.no_coinciden': 'Las contraseñas nuevas no coinciden.',
  'clave.muy_corta': 'La contraseña debe tener al menos 12 caracteres.',
  'clave.guardar': 'Guardar contraseña',
  'clave.restablecida': 'Listo: su contraseña cambió y se cerraron sus sesiones abiertas. Ya puede iniciar sesión.',
  'clave.enlace_invalido': 'El enlace no es válido o está incompleto. Pida uno nuevo.',
  'clave.ir_al_login': 'Ir al inicio de sesión',
  'clave.cambiar_titulo': 'Contraseña',
  'clave.cambiar': 'Cambiar contraseña',
  'clave.cambiada': 'Su contraseña cambió. Se cerraron sus otras sesiones; esta sigue abierta.',

  'mfa.titulo': 'Verificación en dos pasos',
  'mfa.instruccion': 'Ingrese el código de 6 dígitos de su aplicación autenticadora.',
  'mfa.instruccion_recuperacion': 'Ingrese uno de sus códigos de recuperación (XXXXX-XXXXX). Cada código sirve una sola vez.',
  'mfa.codigo': 'Código',
  'mfa.verificar': 'Verificar',
  'mfa.usar_recuperacion': 'Usar un código de recuperación',
  'mfa.usar_aplicacion': 'Usar el código de la aplicación',
  'mfa.desafio_vencido': 'La verificación venció. Inicie sesión de nuevo.',

  'menu.inicio': 'Inicio',
  'menu.tickets': 'Tickets',
  'menu.proyectos': 'Proyectos',
  'menu.tareas': 'Tareas',
  'menu.inventario': 'Inventario',
  'menu.monitoreo': 'Monitoreo',
  'menu.usuarios': 'Usuarios y licencias',
  'menu.conocimiento': 'Base de conocimientos',
  'menu.kpis': 'KPIs',
  'menu.parametros': 'Parametrización',
  'menu.administracion': 'Administración',
  'menu.roles': 'Roles y permisos',
  'menu.asignaciones': 'Roles de usuarios',
  'menu.organizaciones': 'Organizaciones',
  'menu.tenants': 'Tenants',
  'menu.mi_seguridad': 'Mi seguridad',
  'menu.cerrar_sesion': 'Cerrar sesión',
  'menu.abrir_menu': 'Abrir el menú',
  'menu.cerrar_menu': 'Cerrar el menú',
  'menu.colapsar': 'Contraer el menú',
  'menu.expandir': 'Expandir el menú',

  'inicio.saludo': 'Hola, {nombre}',
  'portal.pregunta': '¿En qué le podemos ayudar?',
  'portal.buscar': 'Busque una guía o el número de un ticket',
  'portal.guias': 'Guías',
  'portal.buscar_boton': 'Buscar',
  'portal.acciones': 'Qué necesita',
  'portal.accion_problema': 'Reportar un problema',
  'portal.accion_problema_ayuda': 'Algo que funcionaba dejó de funcionar o anda mal.',
  'portal.accion_pedido': 'Pedir algo a IT',
  'portal.accion_pedido_ayuda': 'Un acceso, un equipo, una instalación o una consulta.',
  'portal.accion_proyecto': 'Solicitar un proyecto',
  'portal.accion_proyecto_ayuda': 'Una mejora o un sistema nuevo; lo aprueba su jefe directo.',
  'portal.accion_equipo': 'Personas de su equipo',
  'portal.accion_equipo_ayuda': 'Pida el alta de alguien nuevo o la baja de quien se va.',
  'portal.por_aprobar': 'Tiene {n} solicitudes de proyecto esperando su aprobación.',
  'portal.revisar': 'Revisarlas',
  'portal.mis_tickets': 'Mis tickets',
  'portal.mis_tareas': 'Mis tareas',
  'portal.solicitudes': 'Solicitudes de proyecto',
  'portal.en_curso': 'En curso',
  'portal.resueltos': 'Resueltos',
  'portal.ver_todos': 'Ver todos mis tickets',
  'portal.sin_en_curso': 'No tiene tickets en curso.',
  'portal.sin_resueltos': 'Todavía no tiene tickets resueltos.',
  'portal.actualizado': 'Actualizado el {fecha}',
  'inicio.descripcion': 'Esta es la base de SIT 365. Los módulos se irán habilitando a medida que se construyan.',
  'inicio.organizaciones': 'Organizaciones a las que tiene acceso',
  'inicio.permisos': 'Permisos activos',

  'aviso.activar_2fa': 'Sus roles {roles} exigen la verificación en dos pasos. No le darán permisos hasta que la active.',
  'aviso.activar_2fa_accion': 'Activarla ahora',

  'seguridad.titulo': 'Mi seguridad',
  'seguridad.2fa': 'Verificación en dos pasos',
  'seguridad.2fa_activa': 'Activa. Al iniciar sesión se le pedirá un código de su aplicación autenticadora.',
  'seguridad.2fa_inactiva': 'No está activa. Actívela para proteger su cuenta; es obligatoria para los roles administrativos.',
  'seguridad.activar': 'Activar',
  'seguridad.paso_qr': '1. Escanee este código con su aplicación autenticadora (Microsoft Authenticator, Google Authenticator u otra).',
  'seguridad.clave_manual': 'Si no puede escanearlo, ingrese esta clave a mano:',
  'seguridad.paso_codigo': '2. Ingrese el código de 6 dígitos que muestra la aplicación.',
  'seguridad.codigos_titulo': 'Guarde sus códigos de recuperación',
  'seguridad.codigos_aviso': 'Úselos si pierde el teléfono. Cada uno sirve una sola vez y no se volverán a mostrar.',
  'seguridad.codigos_descargar': 'Descargar',
  'seguridad.codigos_copiar': 'Copiar',
  'seguridad.codigos_copiados': 'Copiados',
  'seguridad.codigos_listo': 'Ya los guardé',
  'seguridad.regenerar': 'Generar nuevos códigos de recuperación',
  'seguridad.desactivar': 'Desactivar',
  'seguridad.desactivar_confirmar': 'Para desactivarla, ingrese un código de su aplicación o de recuperación.',
  'seguridad.reautenticar': 'Por seguridad, confirme con un código de su aplicación autenticadora.',

  'notificaciones.titulo': 'Notificaciones',
  'notificaciones.vacias': 'No tiene notificaciones.',
  'notificaciones.marcar_todas': 'Marcar todas como leídas',

  'acceso.sin_permiso': 'No tiene permiso para ver esta sección.',
  'acceso.roles_titulo': 'Roles y permisos',
  'acceso.roles_descripcion':
    'Un rol es un paquete de permisos. Se asigna a cada usuario en una organización. Solo puede conceder permisos que usted tiene.',
  'acceso.nuevo_rol': 'Nuevo rol',
  'acceso.rol_nombre': 'Nombre',
  'acceso.rol_clave': 'Clave',
  'acceso.rol_clave_ayuda': 'Identificador fijo: minúsculas, números y guion bajo. No se puede cambiar después.',
  'acceso.rol_2fa': 'Exige verificación en dos pasos (rol administrativo)',
  'acceso.rol_2fa_fijo': 'En los roles iniciales la exigencia de 2FA no se cambia.',
  'acceso.rol_inicial': 'Inicial',
  'acceso.rol_2fa_corto': '2FA',
  'acceso.rol_todos': 'Tiene todos los permisos y no se edita.',
  'acceso.permisos': 'Permisos',
  'acceso.permisos_contador': '{n} permisos',
  'acceso.permisos_todos': 'Todos',
  'acceso.permiso_ajeno': 'Usted no tiene este permiso: no puede concederlo.',
  'acceso.rol_creado': 'Rol creado.',
  'acceso.rol_guardado': 'Cambios guardados.',
  'acceso.rol_borrado': 'Rol borrado.',
  'acceso.borrar_rol': 'Borrar rol',
  'acceso.borrar_rol_confirmar': '¿Borrar el rol {rol}? Solo se puede si nadie lo tiene asignado.',
  'acceso.si_borrar': 'Sí, borrar',
  'acceso.elegir_rol': 'Elija un rol de la lista para ver o editar sus permisos.',
  'acceso.solo_lectura': 'Solo lectura: no tiene permiso para editar roles.',

  'acceso.usuarios_titulo': 'Roles de usuarios',
  'acceso.usuarios_descripcion': 'Asigne o quite roles por organización. Un permiso temporal vence solo en la fecha indicada.',
  'acceso.buscar_usuario': 'Buscar por nombre o correo',
  'acceso.sin_resultados': 'No hay usuarios que coincidan.',
  'acceso.elegir_usuario': 'Elija un usuario para ver y cambiar sus roles.',
  'acceso.roles_de': 'Roles de {nombre}',
  'acceso.sin_roles': 'No tiene roles asignados.',
  'acceso.vence': 'Vence el {fecha}',
  'acceso.vencido': 'Vencido',
  'acceso.quitar': 'Quitar',
  'acceso.quitar_confirmar': '¿Quitar el rol {rol} en {org}?',
  'acceso.si_quitar': 'Sí, quitar',
  'acceso.asignar_titulo': 'Asignar un rol',
  'acceso.rol': 'Rol',
  'acceso.organizacion': 'Organización',
  'acceso.vencimiento': 'Vence (opcional)',
  'acceso.vencimiento_ayuda': 'Déjelo vacío para un rol permanente. Si pone una fecha, el rol deja de valer al terminar ese día.',
  'acceso.asignar': 'Asignar',
  'acceso.asignado': 'Rol asignado. El usuario recibirá un aviso.',
  'acceso.asignado_varias': 'Rol asignado en {n} organizaciones. El usuario recibirá un aviso.',
  'acceso.ya_tenia': 'Ya lo tenía en: {orgs}.',
  'acceso.organizaciones': 'Organizaciones',
  'acceso.organizaciones_ayuda': 'Marque todas en las que la persona tendrá el mismo rol; se asigna en todas de una vez.',
  'acceso.todas': 'Marcar todas',
  'acceso.ninguna': 'Desmarcar',
  'acceso.asignar_en': 'Asignar en {n} organizaciones',
  'acceso.quitado': 'Rol quitado. El usuario recibirá un aviso.',
  'acceso.no_puede_asignar': 'no puede asignarlo',
  'acceso.estado_inactivo': 'Inactivo',

  'plataforma.org_titulo': 'Organizaciones y departamentos',
  'plataforma.org_descripcion':
    'Organizaciones del tenant (líneas de negocio, países o entidades regionales) y sus departamentos. Las áreas son abiertas: se pueden agregar cuando haga falta.',
  'plataforma.nueva_org': 'Nueva organización',
  'plataforma.org_nombre': 'Nombre',
  'plataforma.org_alias': 'Alias (opcional)',
  'plataforma.org_tipo': 'Tipo',
  'plataforma.org_grupo': 'Grupo',
  'plataforma.org_grupo_ayuda': 'Agrupa organizaciones en filtros y reportes (ej. Grupo Siuma, Colliers CAAC).',
  'plataforma.org_pais': 'País',
  'plataforma.org_sin_pais': 'Sin país',
  'plataforma.org_pais_ayuda': 'De él salen los feriados que descuenta el SLA.',
  'plataforma.org_zona': 'Zona horaria',
  'plataforma.org_zona_ayuda': 'Formato IANA, ej. America/Panama. Los SLA se miden en horas hábiles de esta zona.',
  'plataforma.tipo_linea': 'Línea de negocio',
  'plataforma.tipo_pais': 'País',
  'plataforma.tipo_regional': 'Regional',
  'plataforma.org_resumen': '{deps} departamentos · {users} usuarios',
  'plataforma.org_sin_acceso': 'Sin roles',
  'plataforma.org_sin_acceso_ayuda': 'Usted no tiene roles en esta organización: puede administrarla, pero no ve sus datos.',
  'plataforma.org_creada': 'Organización creada.',
  'plataforma.org_creada_superadmin': 'Organización creada. Usted quedó como SuperAdmin en ella.',
  'plataforma.org_guardada': 'Cambios guardados.',
  'plataforma.elegir_org': 'Elija una organización para editarla y ver sus departamentos.',
  'plataforma.departamentos': 'Departamentos',
  'plataforma.sin_departamentos': 'Sin departamentos todavía.',
  'plataforma.nuevo_departamento': 'Nuevo departamento',
  'plataforma.agregar': 'Agregar',
  'plataforma.renombrar': 'Renombrar',
  'plataforma.borrar': 'Borrar',
  'plataforma.dep_usuarios': '{n} usuarios',
  'plataforma.dep_borrar_confirmar': '¿Borrar el departamento {nombre}?',
  'plataforma.semilla': 'Cargar datos iniciales',
  'plataforma.semilla_confirmar':
    'Se crearán las organizaciones, departamentos, puestos y catálogos de Tickets de Grupo Siuma que falten. Lo que ya existe no se modifica. ¿Continuar?',
  'plataforma.semilla_resultado':
    'Datos iniciales cargados: {orgs} organizaciones, {deps} departamentos, {pos} puestos y {tic} registros de los catálogos de Tickets nuevos.',

  'plataforma.tenants_titulo': 'Tenants',
  'plataforma.tenants_descripcion':
    'Cada tenant es una entidad aislada (hoy, Grupo Siuma). Crear un tenant crea sus roles iniciales, su primera organización y su administrador, que recibe una invitación por correo.',
  'plataforma.nuevo_tenant': 'Nuevo tenant',
  'plataforma.tenant_nombre': 'Nombre',
  'plataforma.tenant_subdominio': 'Subdominio',
  'plataforma.tenant_subdominio_ayuda': 'Con él entran sus usuarios. No se puede cambiar después.',
  'plataforma.tenant_primera_org': 'Primera organización',
  'plataforma.tenant_admin': 'Administrador del tenant',
  'plataforma.tenant_admin_correo': 'Correo',
  'plataforma.tenant_admin_nombre': 'Nombre completo',
  'plataforma.tenant_admin_ayuda': 'Será SuperAdmin del tenant. Recibe un enlace para elegir su contraseña (vence en 72 horas).',
  'plataforma.crear_tenant': 'Crear tenant',
  'plataforma.tenant_creado': 'Tenant creado. Se envió la invitación a {correo}.',
  'plataforma.tenant_creado_sin_correo':
    'Tenant creado, pero no se pudo enviar la invitación. El administrador puede pedir el enlace con "¿Olvidó su contraseña?" en {url}.',
  'plataforma.tenant_operador': 'Operador',
  'plataforma.tenant_activo': 'Activo',
  'plataforma.tenant_inactivo': 'Inactivo',
  'plataforma.tenant_resumen': '{orgs} organizaciones · {users} usuarios · cuota {gb} GB',
  'plataforma.tenant_cuota': 'Cuota de adjuntos (GB)',
  'plataforma.tenant_guardado': 'Cambios guardados.',
  'plataforma.editar': 'Editar',
  'plataforma.desactivar': 'Desactivar',
  'plataforma.activar': 'Activar',
  'plataforma.desactivar_confirmar': '¿Desactivar {nombre}? Nadie podrá entrar y se cerrarán todas sus sesiones.',
  'plataforma.si_desactivar': 'Sí, desactivar',
  'plataforma.operador_fijo': 'Es el tenant operador de la plataforma: no se puede desactivar.',

  'param.titulo': 'Parametrización',
  'param.descripcion': 'Configuración de la plataforma sin tocar código (D18). Lo acordado en reuniones son valores por defecto: aquí se ajustan.',
  'param.generales': 'Parámetros generales',
  'param.catalogos': 'Catálogos',
  'param.por_defecto': 'Por defecto: {valor}',
  'param.modificado_por': 'Cambiado por {nombre} el {fecha}',
  'param.restablecer': 'Restablecer',
  'param.guardado': 'Guardado.',
  'param.restablecido': 'Se restableció el valor por defecto.',
  'param.si': 'Sí',
  'param.no': 'No',
  'param.activado': 'Activado',
  'param.elegir_seccion': 'Elija una sección.',
  'cat.nuevo': 'Nuevo',
  'cat.editar': 'Editar',
  'cat.desactivar': 'Desactivar',
  'cat.activar': 'Activar',
  'cat.subir': 'Subir',
  'cat.bajar': 'Bajar',
  'cat.mostrar_inactivos': 'Mostrar inactivos',
  'cat.inactivo': 'Inactivo',
  'cat.vacio': 'No hay registros todavía.',
  'cat.creado': 'Registro creado.',
  'cat.guardado': 'Cambios guardados.',
  'cat.estado': 'Estado',
  'cat.acciones': 'Acciones',
  'cat.no_se_borran': 'Los registros no se borran porque pueden estar en uso: se desactivan y dejan de ofrecerse.',

  'cal.titulo': 'Calendario laboral',
  'cal.descripcion':
    'Horario de cada organización, en su hora local: de él sale el SLA en horas hábiles. Un día puede tener varios tramos (ej. con almuerzo). Sin horario propio, vale el de por defecto: lunes a viernes, 8:00 a 17:00.',
  'cal.propio': 'Propio',
  'cal.por_defecto': 'Por defecto',
  'cal.elegir': 'Elija una organización para ver o cambiar su horario.',
  'cal.zona': 'Zona horaria: {zona}.',
  'cal.usa_defecto': 'Hoy usa el horario por defecto.',
  'cal.dias': 'Días de la semana',
  'cal.dia_1': 'Lunes',
  'cal.dia_2': 'Martes',
  'cal.dia_3': 'Miércoles',
  'cal.dia_4': 'Jueves',
  'cal.dia_5': 'Viernes',
  'cal.dia_6': 'Sábado',
  'cal.dia_7': 'Domingo',
  'cal.no_laborable': 'No laborable',
  'cal.desde_dia': '{dia}, tramo {n}: desde',
  'cal.hasta_dia': '{dia}, tramo {n}: hasta',
  'cal.quitar_tramo': 'Quitar el tramo {n} del {dia}',
  'cal.agregar_tramo': '+ Agregar tramo',
  'cal.copiar_lunes': 'Copiar el lunes a todos los días hábiles',
  'cal.guardado': 'Horario guardado.',
  'cal.restablecer': 'Volver al horario por defecto',
  'cal.restablecido': 'La organización vuelve a usar el horario por defecto.',

  'fer.titulo': 'Feriados',
  'fer.descripcion':
    'Feriados de cada país: el SLA no corre en ellos. Aplican a todas las organizaciones de ese país. Se cargan una vez al año, uno a uno o con un archivo CSV.',
  'fer.pais': 'País',
  'fer.anio': 'Año',
  'fer.aplica_a': 'Aplica a: {orgs}.',
  'fer.vacio': 'No hay feriados cargados para {anio}.',
  'fer.sin_paises': 'Ninguna organización tiene país todavía. Indíquelo en Administración → Organizaciones.',
  'fer.agregar': 'Agregar un feriado',
  'fer.fecha': 'Fecha',
  'fer.nombre': 'Nombre',
  'fer.agregado': 'Feriado agregado.',
  'fer.borrado': 'Feriado borrado.',
  'fer.borrar_confirmar': '¿Borrar el feriado {nombre}?',
  'fer.importar': 'Importar desde un CSV',
  'fer.importar_ayuda':
    'Una línea por feriado: fecha y nombre, separados por coma o punto y coma. Fechas AAAA-MM-DD o DD/MM/AAAA. Si alguna línea tiene un error, no se importa nada; una fecha que ya existe actualiza su nombre.',
  'fer.archivo': 'Archivo CSV de feriados',
  'fer.importado': 'Importación lista: {nuevos} feriados nuevos y {actualizados} actualizados.',
  'fer.linea': 'Línea {n}: {mensaje}',

  'tk.titulo': 'Tickets',
  'tk.descripcion': 'Pedidos y problemas reportados al Departamento de IT.',
  'tk.nuevo': 'Nuevo ticket',
  'tk.nuevo_ayuda': 'Cuéntenos qué pasa con sus palabras. IT lo clasifica, le asigna la prioridad y le responde por aquí y por correo.',
  'tk.alcance': 'Qué tickets ver',
  'tk.alcance_propios': 'Mis tickets',
  'tk.alcance_asignados': 'Asignados a mí',
  'tk.alcance_todos': 'Todos',
  'tk.estado': 'Estado',
  'tk.filtro_abiertos': 'Abiertos',
  'tk.filtro_en_cola': 'En cola',
  'tk.filtro_en_curso': 'En curso',
  'tk.filtro_terminado': 'Terminados',
  'tk.filtro_cancelado': 'Cancelados',
  'tk.filtro_todos': 'Todos los estados',
  'tk.buscar': 'Buscar',
  'tk.buscar_ayuda': 'Título o número (T-000123)',
  'tk.vacio': 'No hay tickets con este filtro.',
  'tk.sin_resultados': 'Ningún ticket coincide con la búsqueda.',
  'tk.ver_mas': 'Ver más',
  'tk.col_ticket': 'Ticket',
  'tk.col_estado': 'Estado',
  'tk.col_prioridad': 'Prioridad',
  'tk.col_vence': 'Vence',
  'tk.col_creado': 'Creado',
  'tk.sin_clasificar': 'Sin clasificar',
  'tk.sin_prioridad': 'Sin prioridad',
  'tk.sin_asignar': 'Sin asignar',
  'tk.vencio': 'Venció {fecha}',
  'tk.naturaleza_incidencia': 'Incidencia',
  'tk.naturaleza_solicitud': 'Solicitud',
  'tk.naturaleza_cambio': 'Cambio',
  'tk.naturaleza_incidencia_ayuda': 'Algo que funcionaba dejó de funcionar o anda mal.',
  'tk.naturaleza_solicitud_ayuda': 'Un pedido: un acceso, un equipo, una instalación, una consulta.',
  'tk.naturaleza_cambio_ayuda': 'Modificar algo que ya existe: una configuración, un reporte, un proceso.',
  'tk.campo_titulo': 'Título',
  'tk.campo_descripcion': 'Descripción',
  'tk.campo_descripcion_ayuda': 'Qué pasa, desde cuándo, a quién afecta y, si aparece, el mensaje de error.',
  'tk.campo_naturaleza': 'Tipo',
  'tk.campo_app': 'Aplicación o sistema afectado',
  'tk.app_ninguna': 'Ninguna / no sé',
  'tk.enviar': 'Enviar ticket',
  'tk.creado': 'Ticket {codigo} creado. Le avisaremos por correo cuando IT responda.',
  'tk.descripcion_titulo': 'Descripción',
  'tk.datos': 'Datos',
  'tk.solicitante': 'Solicitante',
  'tk.responsable': 'Responsable',
  'tk.categoria': 'Categoría',
  'tk.subcategoria': 'Subcategoría',
  'tk.subcategoria_sla': '{nombre} ({horas} h)',
  'tk.prioridad': 'Prioridad',
  'tk.elegir': 'Elegir…',
  'tk.historial': 'Historial de estados',
  'tk.hilo': 'Conversación',
  'tk.hilo_vacio': 'Todavía no hay respuestas.',
  'tk.autor_sistema': 'Sistema',
  'tk.nota_interna': 'Nota interna',
  'tk.sla': 'Tiempo de atención (SLA)',
  'tk.sla_progreso': 'Tiempo de atención consumido',
  'tk.sla_sin_sla': 'Sin SLA todavía: se calcula cuando IT clasifica el ticket.',
  'tk.sla_esperando': 'El reloj arranca con la primera respuesta de IT.',
  'tk.sla_meta': 'Meta: {meta} hábiles.',
  'tk.sla_vence': 'Vence el {fecha}',
  'tk.sla_restante': 'Quedan {tiempo} hábiles de {meta}.',
  'tk.sla_vencido': 'Vencido hace {tiempo} hábiles',
  'tk.sla_en_pausa': 'En pausa desde el {fecha}',
  'tk.sla_consumido': 'Consumido: {tiempo} de {meta} hábiles.',
  'tk.sla_cumplido': 'Cumplido',
  'tk.sla_incumplido': 'Incumplido',
  'tk.sla_cancelado': 'El ticket se canceló.',
  'tk.sla_pausado': 'En pausa',
  'tk.triage': 'Clasificación (IT)',
  'tk.triage_guardado': 'Clasificación guardada.',
  'tk.cambiar_estado': 'Cambiar estado',
  'tk.nuevo_estado': 'Nuevo estado',
  'tk.estado_pausa': '{nombre} (pausa el SLA)',
  'tk.estado_cambiado': 'Estado actualizado.',
  'tk.cancelar_ayuda': '¿Ya no lo necesita? Puede cancelarlo mientras IT no lo haya tomado.',
  'tk.cancelar_ticket': 'Cancelar el ticket',
  'tk.cancelar_confirmar': '¿Cancelar este ticket? IT no lo atenderá.',
  'tk.si_cancelar': 'Sí, cancelar',
  'tk.cancelado': 'Ticket cancelado.',
  'tk.tomar': 'Tomar',
  'tk.tomar_este': 'Tomar este ticket',
  'tk.tomar_ayuda': 'Tómelo cuando empiece a trabajar en él: queda como su ticket activo y, si nadie lo tenía, asignado a usted.',
  'tk.tomar_conflicto': 'Ya está trabajando en {codigo} ({titulo}). La política es terminarlo antes de tomar otro, salvo urgencia real. ¿Es una urgencia?',
  'tk.tomar_urgente': 'Sí, es urgente: tomarlo',
  'tk.soltar': 'Dejar de trabajar en él',
  'tk.soltado': 'Ya no es su ticket activo.',
  'tk.activo_suyo': 'Es su ticket activo',
  'tk.activo_de': 'Ticket activo de {nombre}',
  'tk.sla_corto_quedan': 'Quedan {tiempo}',
  'tk.sla_corto_vencido': 'Vencido hace {tiempo}',
  'tk.sla_corto_esperando': 'Sin primera respuesta',
  'tk.sla_corto_sin_sla': 'Sin SLA',
  'panel.resumen': 'Resumen de sus tickets',
  'panel.mis_abiertos': 'Mis tickets abiertos',
  'panel.por_vencer': 'Por vencer (≥ {pct} %)',
  'panel.vencidos': 'Vencidos',
  'panel.en_pausa': 'En pausa',
  'panel.sin_responsable': 'Sin responsable',
  'panel.activo': 'Ticket activo',
  'panel.sin_activo': 'No está trabajando en ningún ticket. Tome el más urgente de su lista o uno de la cola.',
  'panel.activo_desde': 'activo desde {fecha}',
  'panel.abrir': 'Abrir el ticket',
  'panel.mis_tickets': 'Mis tickets, por urgencia',
  'panel.mis_tickets_vacio': 'No tiene otros tickets abiertos.',
  'panel.cola': 'Cola sin responsable',
  'panel.cola_vacia': 'No hay tickets esperando responsable.',
  'panel.entro': 'entró {fecha}',
  'tk.hilo_cerrado': 'El ticket está cancelado: ya no se puede responder.',
  'tk.escribir_respuesta': 'Escribir una respuesta',
  'tk.escribir_nota': 'Escribir una nota interna',
  'tk.nota_interna_check': 'Nota interna (solo la ve IT)',
  'tk.enviar_respuesta': 'Enviar respuesta',
  'tk.guardar_nota': 'Guardar nota',
  'tk.enviado': 'Respuesta enviada.',
  'tk.enviado_sla': 'Respuesta enviada. Fue la primera respuesta: el reloj del SLA empezó a correr.',
  'tk.nota_guardada': 'Nota interna guardada.',
  'tk.arranca_sla': 'Es la primera respuesta pública: al enviarla arranca el reloj del SLA.',
  'tk.aviso_it': 'IT recibe un aviso con su respuesta.',
  'tk.adjuntar_ayuda': 'PDF, imágenes, documentos de Office, ZIP o texto. Los ve todo el que ve el ticket.',
  'tk.encuesta': '¿Cómo le fue?',
  'tk.encuesta_pregunta': 'Su ticket quedó resuelto. Califique la atención: nos ayuda a mejorar.',
  'tk.encuesta_calificacion': 'Calificación',
  'tk.encuesta_1': '1: Muy mala',
  'tk.encuesta_2': '2: Mala',
  'tk.encuesta_3': '3: Regular',
  'tk.encuesta_4': '4: Buena',
  'tk.encuesta_5': '5: Excelente',
  'tk.encuesta_comentario': 'Comentario (opcional)',
  'tk.encuesta_enviar': 'Enviar calificación',
  'tk.encuesta_gracias': '¡Gracias por su calificación!',
  'tk.encuesta_valor': '{n} de 5',

  'pr.titulo': 'Proyectos',
  'pr.descripcion': 'Los proyectos de IT: su plan por fases, el tablero de tareas y la línea de tiempo.',
  'pr.secciones': 'Secciones de Proyectos',
  'pr.nuevo': 'Nuevo proyecto',
  'pr.nuevo_ayuda': 'Para un proyecto que no viene de una solicitud (ej. uno interno de IT). Si elige un tipo, se precargan sus fases.',
  'pr.alcance': 'Qué proyectos ver',
  'pr.alcance_mios': 'Mis proyectos',
  'pr.alcance_todos': 'Todos',
  'pr.estado': 'Estado',
  'pr.filtro_activos': 'Activos',
  'pr.filtro_todos': 'Todos los estados',
  'pr.estado_planificacion': 'En planificación',
  'pr.estado_en_curso': 'En curso',
  'pr.estado_en_pausa': 'En pausa',
  'pr.estado_terminado': 'Terminado',
  'pr.estado_cancelado': 'Cancelado',
  'pr.buscar': 'Buscar',
  'pr.buscar_ayuda': 'Nombre o número (PR-000123)',
  'pr.vacio': 'No hay proyectos con este filtro.',
  'pr.sin_resultados': 'Ningún proyecto coincide con la búsqueda.',
  'pr.col_proyecto': 'Proyecto',
  'pr.col_estado': 'Estado',
  'pr.col_responsable': 'Responsable',
  'pr.col_avance': 'Avance',
  'pr.col_vence': 'Vence',
  'pr.prioridad_corta': 'Prioridad {prioridad}',
  'pr.sin_responsable': 'Sin responsable',
  'pr.avance': 'Avance',
  'pr.avance_texto': '{hechas} de {total}',
  'pr.organizacion': 'Línea de negocio',
  'pr.nombre': 'Nombre',
  'pr.descripcion_campo': 'Descripción',
  'pr.tipo': 'Tipo de proyecto',
  'pr.tipo_ninguno': 'Sin tipo (sin plantilla)',
  'pr.prioridad': 'Prioridad interna',
  'pr.responsable': 'Responsable',
  'pr.inicio': 'Inicio',
  'pr.vence': 'Vencimiento',
  'pr.etiquetas': 'Etiquetas',
  'pr.plantilla_ayuda': 'Se crean las fases y pasos de la plantilla del tipo; después se ajustan en el plan.',
  'pr.sin_plantilla_ayuda': 'Sin tipo, el proyecto empieza sin fases: se agregan desde el plan.',
  'pr.crear': 'Crear proyecto',
  'pr.creado': 'Proyecto {codigo} creado.',
  'pr.vistas': 'Vistas del plan',
  'pr.vista_lista': 'Lista',
  'pr.vista_tablero': 'Tablero',
  'pr.vista_cronograma': 'Línea de tiempo',
  'pr.datos': 'Datos',
  'pr.solicitud': 'Solicitud',
  'pr.editar': 'Editar el proyecto',
  'pr.plan_vacio': 'El proyecto todavía no tiene fases.',
  'pr.pasos_hechos': '{hechos} de {total} pasos',
  'pr.vence_el': 'vence {fecha}',
  'pr.vencio_el': 'venció {fecha}',
  'pr.agregar': 'Agregar',
  'pr.agregar_fase': 'Agregar una fase',
  'pr.agregar_paso': 'Agregar un paso',
  'pr.bloqueada': 'No se puede terminar "{tarea}": depende de tareas que siguen abiertas.',
  'pr.depende_de': 'depende de {n}',
  'pr.mover': 'Mover "{tarea}" a',
  'pr.documentos': 'Documentos',
  'pr.documentos_vacio': 'Todavía no hay documentos.',
  'pr.documento_nuevo': 'Nuevo documento',
  'pr.descargar_version': 'Descargar v{version}',
  'pr.sin_versiones': 'Sin versiones',
  'pr.ver_historial': 'Ver las {n} versiones',
  'pr.ocultar_historial': 'Ocultar versiones',
  'pr.nota_version': 'Nota de la versión (opcional)',
  'pr.nota_version_de': 'Nota de la nueva versión de {documento}',
  'pr.subir_version': 'Subir una versión',
  'pr.subir_version_de': 'Subir una versión de {documento}',
  'pr.adjuntos_ayuda': 'PDF, imágenes, documentos de Office, ZIP o texto. Los ve todo el que ve el proyecto.',
  'gantt.sin_fechas': 'Ninguna tarea tiene fechas todavía: póngales inicio y vencimiento para verlas en la línea de tiempo.',
  'gantt.tarea': 'Tarea',
  'gantt.del_al': 'del {desde} al {hasta}',
  'gantt.el': 'el {fecha}',
  'gantt.sin_fecha': 'sin fecha',
  'gantt.leyenda': 'Barras: gris por hacer, azul en curso, verde terminada, roja atrasada. Las fases sin fechas propias se ven más tenues. La línea roja es hoy.',
  'ta.titulo': 'Mis tareas',
  'ta.personal': 'Tarea personal',
  'ta.atrasada': 'Atrasada',
  'ta.se_repite': 'Se repite: {regla}',
  'ta.de_una_serie': 'ver la serie',
  'ta.descripcion': 'Descripción',
  'ta.estado': 'Estado',
  'ta.nuevo_estado': 'Nuevo estado',
  'ta.elegir': 'Elegir…',
  'ta.cambiar_estado': 'Cambiar estado',
  'ta.bloqueada': 'No se puede terminar: depende de tareas que siguen abiertas.',
  'ta.siguiente_creada': 'Es una tarea que se repite: se creó la siguiente, que vence el {fecha}.',
  'ta.ver_siguiente': 'Ver la siguiente',
  'ta.datos': 'Datos',
  'ta.asignados': 'Asignados',
  'ta.sin_asignar': 'Sin asignar',
  'ta.prioridad': 'Prioridad',
  'ta.inicio': 'Inicio',
  'ta.vence': 'Vencimiento',
  'ta.estimacion': 'Estimación',
  'ta.estimacion_horas': 'Estimación (horas)',
  'ta.horas': '{n} h',
  'ta.creada_por': 'Creada por',
  'ta.etiquetas': 'Etiquetas',
  'ta.editar': 'Editar',
  'ta.titulo_campo': 'Título',
  'ta.dependencias': 'Dependencias',
  'ta.depende_de': 'Depende de',
  'ta.sin_dependencias': 'No depende de otras tareas.',
  'ta.bloquea_a': 'Bloquea a',
  'ta.quitar_dependencia': 'Quitar la dependencia de {tarea}',
  'ta.agregar_dependencia': 'Agregar una dependencia',
  'ta.agregar': 'Agregar',
  'ta.pasos': 'Pasos',
  'ta.subtareas': 'Subtareas',
  'ta.sin_subtareas': 'No tiene subtareas.',
  'ta.nueva_subtarea': 'Nueva subtarea',
  'ta.comentarios': 'Comentarios',
  'ta.sin_comentarios': 'Todavía no hay comentarios.',
  'ta.escribir_comentario': 'Escribir un comentario',
  'ta.comentar': 'Comentar',
  'ta.tiempo': 'Tiempo dedicado',
  'ta.tiempo_total': 'Tiempo dedicado: {total}',
  'ta.dia': 'Día',
  'ta.horas_campo': 'Horas',
  'ta.nota': 'Nota',
  'ta.registrar': 'Registrar',
  'ta.borrar_tiempo': 'Borrar el registro de {tiempo}',
  'ta.historial': 'Historial de estados',
  'ta.borrar': 'Borrar la tarea',
  'ta.borrar_confirmar': '¿Borrar esta tarea? No se puede deshacer.',
  'ta.borrar_confirmar_con_pasos': '¿Borrar esta tarea y sus {n} subtareas? No se puede deshacer.',
  'ta.si_borrar': 'Sí, borrar',
  'ta.repetir': 'Repetir',
  'ta.repetir_ayuda': 'Al terminarla se crea la siguiente con la fecha que corresponde.',
  'ta.frecuencia': 'Frecuencia',
  'ta.frecuencia_none': 'No se repite',
  'ta.frecuencia_DAILY': 'Diaria',
  'ta.frecuencia_WEEKLY': 'Semanal',
  'ta.frecuencia_MONTHLY': 'Mensual',
  'ta.frecuencia_YEARLY': 'Anual',
  'ta.intervalo': 'Cada cuántos',
  'ta.dias_semana': 'Días de la semana',
  'ta.cada_uno': 'cada {unidad}',
  'ta.cada_n': 'cada {n} {unidad}',
  'ta.cada_dias': '{cada}, los {dias}',
  'ta.dia_MO': 'lunes',
  'ta.dia_TU': 'martes',
  'ta.dia_WE': 'miércoles',
  'ta.dia_TH': 'jueves',
  'ta.dia_FR': 'viernes',
  'ta.dia_SA': 'sábados',
  'ta.dia_SU': 'domingos',
  'ta.dia_corto_MO': 'Lu',
  'ta.dia_corto_TU': 'Ma',
  'ta.dia_corto_WE': 'Mi',
  'ta.dia_corto_TH': 'Ju',
  'ta.dia_corto_FR': 'Vi',
  'ta.dia_corto_SA': 'Sá',
  'ta.dia_corto_SU': 'Do',

  'ta.descripcion_vista': 'Sus tareas personales y las de proyectos que tiene asignadas.',
  'ta.descripcion_it': 'Sus tareas personales, las de proyectos que tiene asignadas y sus tickets.',
  'ta.nueva': 'Nueva tarea',
  'ta.nueva_ayuda': 'Una tarea personal: la ven usted y quienes asigne. Las de un proyecto se crean desde su plan.',
  'ta.crear': 'Crear tarea',
  'ta.yo': '{nombre} (yo)',
  'ta.repetir_sin_fecha': 'Sin vencimiento, la siguiente se cuenta desde el día en que la termine.',
  'ta.resumen': 'Resumen semanal',
  'ta.vistas': 'Vistas',
  'ta.vista_lista': 'Lista',
  'ta.vista_cronograma': 'Línea de tiempo',
  'ta.agrupar': 'Agrupar por',
  'ta.agrupar_fecha': 'Fecha',
  'ta.agrupar_proyecto': 'Proyecto',
  'ta.agrupar_estado': 'Estado',
  'ta.incluir_terminadas': 'Incluir terminadas',
  'ta.vacio': 'No tiene tareas abiertas. ¡Todo al día!',
  'ta.ticket': 'Ticket',
  'ta.tickets': 'Tickets',
  'ta.sla_vence': 'SLA: {fecha}',
  'ta.cuando_vencidas': 'Vencidas',
  'ta.cuando_hoy': 'Hoy',
  'ta.cuando_semana': 'Esta semana',
  'ta.cuando_despues': 'Más adelante',
  'ta.cuando_sin_fecha': 'Sin fecha',
  're.titulo': 'Resumen de mis tareas',
  're.titulo_proyecto': 'Resumen de {proyecto}',
  're.descripcion': 'Armado por reglas, sin IA: lo que se hizo, lo que sigue, lo que viene y lo que necesita atención. Sirve para el weekly.',
  're.periodo': 'Período',
  're.semanal': 'Semanal',
  're.mensual': 'Mensual',
  're.anterior_semana': 'Semana anterior',
  're.siguiente_semana': 'Semana siguiente',
  're.esta_semana': 'Esta semana',
  're.anterior_mes': 'Mes anterior',
  're.siguiente_mes': 'Mes siguiente',
  're.este_mes': 'Este mes',
  're.copiar': 'Copiar el párrafo',
  're.copiado': 'Copiado.',
  're.hecho': 'Qué se hizo',
  're.hecho_vacio': 'No se terminó nada en el período.',
  're.en_curso': 'Qué sigue en curso',
  're.en_curso_vacio': 'Nada en curso.',
  're.viene': 'Qué viene ({desde} – {hasta})',
  're.viene_vacio': 'Nada programado para el período siguiente.',
  're.atencion': 'Atención',
  're.atencion_vacio': 'No hay pendientes vencidos.',
  're.terminada_el': 'terminada el {fecha}',
  're.vence_el': 'vence el {fecha}',
  're.resuelto_el': 'resuelto el {fecha}',
  'ca.titulo': 'Cancha de proyectos',
  'ca.titulo_corto': 'Cancha',
  'ca.descripcion': 'En cada proyecto activo, quién tiene la pelota: la tarea en curso (o la próxima) y si su responsable es de IT o del negocio. Se marcan los proyectos sin movimiento.',
  'ca.organizacion': 'Línea de negocio',
  'ca.todas': 'Todas',
  'ca.solo_estancados': 'Solo los que no tienen movimiento',
  'ca.resumen': 'Proyectos por lado',
  'ca.lado_it': 'IT',
  'ca.lado_negocio': 'Negocio',
  'ca.lado_ambos': 'IT y negocio',
  'ca.lado_sin_asignar': 'Sin asignar',
  'ca.lado_sin_tareas': 'Sin tareas abiertas',
  'ca.sin_movimiento': 'Sin movimiento ({dias}+ días hábiles)',
  'ca.vacio': 'No hay proyectos activos.',
  'ca.vacio_estancados': 'Ningún proyecto está sin movimiento. ¡Bien!',
  'ca.col_proyecto': 'Proyecto',
  'ca.col_pelota': 'Tiene la pelota',
  'ca.col_lado': 'Lado',
  'ca.col_movimiento': 'Movimiento',
  'ca.sin_asignados': 'sin asignar',
  'ca.nada_abierto': 'No quedan tareas abiertas: falta cerrar el proyecto.',
  'ca.dias_sin_movimiento': '{n} días hábiles sin movimiento',
  'ca.ultimo': 'último: {fecha}',
  'ca.alerta': 'Sin movimiento hace {n} días hábiles',
  'ca.pelota_en': 'La pelota está en',
  'pr.ver_resumen': 'Ver el resumen semanal del proyecto',

  'sp.titulo': 'Solicitudes de proyecto',
  'sp.descripcion': 'Pida un proyecto a IT. Lo aprueba su jefe directo, IT evalúa si es viable y el Gerente de IT da la aprobación final.',
  'sp.nueva': 'Nueva solicitud',
  'sp.nueva_ayuda': 'Cuéntenos el problema y el beneficio que espera. IT define la prioridad y el tipo de proyecto.',
  'sp.alcance': 'Qué solicitudes ver',
  'sp.alcance_propias': 'Mis solicitudes',
  'sp.alcance_por_aprobar': 'Por aprobar',
  'sp.alcance_todas': 'Todas',
  'sp.estado': 'Estado',
  'sp.filtro_abiertas': 'En aprobación',
  'sp.filtro_aprobada': 'Aprobadas',
  'sp.filtro_rechazada': 'Rechazadas',
  'sp.filtro_retirada': 'Retiradas',
  'sp.filtro_todas': 'Todas',
  'sp.vacio': 'No hay solicitudes con este filtro.',
  'sp.vacio_por_aprobar': 'No tiene solicitudes esperando su decisión.',
  'sp.col_solicitud': 'Solicitud',
  'sp.col_etapa': 'Etapa',
  'sp.col_solicitante': 'Solicitante',
  'sp.col_prioridad': 'Prioridad',
  'sp.col_fecha': 'Pedida',
  'sp.urgencia_corta': 'Urgencia: {urgencia}',
  'sp.estado_jefe': 'Con el jefe directo',
  'sp.estado_viabilidad': 'En viabilidad con IT',
  'sp.estado_gerente': 'Con el Gerente de IT',
  'sp.estado_aprobada': 'Aprobada',
  'sp.estado_rechazada': 'Rechazada',
  'sp.estado_retirada': 'Retirada',
  'sp.etapa_jefe': 'Jefe directo',
  'sp.etapa_viabilidad': 'Viabilidad con IT',
  'sp.etapa_gerente': 'Gerente de IT',
  'sp.etapas': 'Etapas de la aprobación',
  'sp.paso_aprobada': 'aprobada',
  'sp.paso_rechazada': 'rechazada',
  'sp.paso_actual': 'etapa actual',
  'sp.paso_pendiente': 'pendiente',
  'sp.prioridad_alta': 'Alta',
  'sp.prioridad_media': 'Media',
  'sp.prioridad_baja': 'Baja',
  'sp.prioridad_interna': 'Prioridad interna: {prioridad}',
  'sp.aprobara': 'La primera aprobación es de su jefe directo, {jefe}. Después IT evalúa la viabilidad y el Gerente de IT da la aprobación final.',
  'sp.sin_jefe': 'No tiene un jefe directo cargado: la solicitud pasa directo a la evaluación de viabilidad con IT.',
  'sp.campo_titulo': 'Título',
  'sp.campo_problema': 'Problema o necesidad',
  'sp.campo_problema_ayuda': 'Qué pasa hoy, a quién afecta y por qué hace falta resolverlo.',
  'sp.campo_beneficio': 'Beneficio esperado',
  'sp.campo_beneficio_ayuda': 'Qué mejora: horas ahorradas, errores que se evitan, ventas, cumplimiento…',
  'sp.campo_area': 'Área afectada',
  'sp.campo_fecha': 'Fecha ideal',
  'sp.campo_linea': 'Línea de negocio',
  'sp.linea_propia': 'Para: {linea}.',
  'sp.campo_urgencia': 'Urgencia que percibe',
  'sp.campo_urgencia_ayuda': 'Es orientativa: la prioridad del proyecto la define IT.',
  'sp.campo_adjuntos': 'Adjuntos (opcional)',
  'sp.adjuntos_elegidos': '{n} archivo(s) para adjuntar.',
  'sp.adjuntos_ayuda': 'PDF, imágenes, documentos de Office, ZIP o texto. Los ven quienes participan en la solicitud.',
  'sp.adjuntos_fallidos': 'La solicitud se creó, pero no se pudieron adjuntar: {archivos}. Puede volver a subirlos aquí abajo.',
  'sp.enviar': 'Enviar solicitud',
  'sp.enviando': 'Enviando…',
  'sp.creada': 'Solicitud {codigo} enviada. Le avisaremos de cada decisión.',
  'sp.proyecto_creado': 'Solicitud aprobada: se creó el proyecto {codigo}.',
  'sp.ver_proyecto': 'Ver el proyecto',
  'sp.datos': 'Datos',
  'sp.jefe': 'Jefe directo',
  'sp.sin_jefe_corto': 'Sin jefe cargado',
  'sp.tipo': 'Tipo de proyecto',
  'sp.tipo_pendiente': 'Lo asigna IT',
  'sp.decisiones': 'Decisiones',
  'sp.sin_decisiones': 'Todavía nadie decidió.',
  'sp.decision_aprobo': '{quien} aprobó ({etapa})',
  'sp.decision_rechazo': '{quien} rechazó ({etapa})',
  'sp.decidir': 'Su decisión: {etapa}',
  'sp.decidir_ayuda_jefe': 'Como jefe directo, apruebe o rechace la solicitud. Puede ajustar la prioridad interna (el solicitante no la ve).',
  'sp.decidir_ayuda_viabilidad': 'Evalúe si se puede hacer en casa y asígnele el tipo de proyecto: de él sale la plantilla de fases. Si no es viable, recházela con el motivo (ej. se busca un proveedor externo).',
  'sp.decidir_ayuda_gerente': 'Aprobación final: se crea el proyecto con la plantilla de su tipo. Puede ajustar la prioridad y elegir al responsable.',
  'sp.prioridad': 'Prioridad interna',
  'sp.elegir': 'Elegir…',
  'sp.responsable': 'Responsable del proyecto',
  'sp.sin_responsable': 'Lo elijo después',
  'sp.motivo': 'Comentario o motivo',
  'sp.motivo_ayuda': 'Para rechazar hace falta un motivo: se le muestra al solicitante.',
  'sp.aprobar': 'Aprobar',
  'sp.aprobar_final': 'Aprobar y crear el proyecto',
  'sp.rechazar': 'Rechazar',
  'sp.confirmar_alta': 'Sí, estoy seguro',
  'sp.aprobada_ok': 'Aprobada: pasó a la siguiente etapa.',
  'sp.rechazada_ok': 'Solicitud rechazada. El solicitante recibe el aviso con el motivo.',
  'sp.retirar': 'Retirar la solicitud',
  'sp.retirar_ayuda': '¿Ya no la necesita? Puede retirarla mientras está en aprobación.',
  'sp.retirar_confirmar': '¿Retirar esta solicitud? Ya no se evaluará.',
  'sp.si_retirar': 'Sí, retirarla',

  'adj.titulo': 'Adjuntos',
  'adj.vacio': 'No hay archivos adjuntos.',
  'adj.adjuntar': 'Adjuntar archivos',
  'adj.ayuda': 'PDF, imágenes, documentos de Office, ZIP o texto.',
  'adj.subiendo': 'Subiendo…',
  'adj.borrar_confirmar': '¿Borrar el adjunto {nombre}?',

  'us.secciones': 'Secciones de Usuarios',
  'us.portal': 'Portal de autoservicio de RR. HH.',
  'us.portal_corto': 'Portal RR. HH.',
  'us.portal_descripcion': 'Altas y bajas de colaboradores, y los pedidos a IT de reset de MFA o de contraseña (crean un ticket).',
  'us.portal_por_aprobar': 'Esperan su decisión',
  'us.portal_altas_pendientes': 'Altas por aprobar: {n}',
  'us.portal_bajas_pendientes': 'Bajas por aprobar: {n}',
  'us.portal_solicitar': 'Solicitar',
  'us.portal_reset': 'Reset de MFA o de contraseña',
  'us.portal_reset_ayuda': 'Busque a la persona. El pedido crea un ticket para IT a su nombre y lo puede seguir desde Tickets.',
  'us.altas': 'Altas',
  'us.bajas': 'Bajas',
  'us.directorio': 'Directorio',
  'us.directorio_descripcion': 'Colaboradores de sus organizaciones. Abra la ficha de una persona para corregir sus datos, cambiar su jefe o cargo y sus licencias; RR. HH. pide desde aquí el reset de MFA o de contraseña, o la baja.',
  'us.directorio_vacio': 'No hay personas que coincidan.',
  'us.importar': 'Importación inicial de usuarios',
  'us.importar_corto': 'Importar',
  'us.importar_descripcion': 'Los usuarios actuales se importan una sola vez. Después, cada persona nueva entra por una solicitud de alta.',
  'us.importar_formato': 'Formato (CSV separado por punto y coma, con encabezado)',
  'us.importar_formato_ayuda':
    'La organización, el departamento y el cargo van por nombre; el jefe, por correo (puede estar en el mismo archivo). Si una línea tiene un error no se importa nada. Los correos que ya existen se saltan.',
  'us.importar_archivo': 'Archivo CSV',
  'us.importar_lineas': '{archivo}: {n} líneas',
  'us.importar_invitar': 'Enviar la invitación por correo a cada persona creada',
  'us.importar_invitar_ayuda': 'Con la invitación cada persona elige su contraseña. Si no la envía ahora, la puede pedir con "¿Olvidó su contraseña?".',
  'us.importar_boton': 'Importar',
  'us.importando': 'Importando…',
  'us.importar_ok': 'Listo: {creados} creados, {saltados} ya existían, {invitaciones} invitaciones enviadas.',
  'us.importar_linea': 'Línea {linea}: {motivo}',
  'us.altas_titulo': 'Altas de colaboradores',
  'us.altas_descripcion': 'Pida el alta de una persona nueva de su equipo. RR. HH. la aprueba y, al aprobarla, se crea su usuario y las tareas para IT.',
  'us.altas_nueva': 'Solicitar alta',
  'us.bajas_titulo': 'Bajas de colaboradores',
  'us.bajas_descripcion': 'Pida la baja de una persona de su equipo. RR. HH. la aprueba y, al aprobarla, se generan las tareas para cerrar sus licencias y recuperar el equipo.',
  'us.bajas_nueva': 'Solicitar baja',
  'us.alcance': 'Qué solicitudes ver',
  'us.alcance_propias': 'Mis solicitudes',
  'us.alcance_por_aprobar': 'Por aprobar',
  'us.alcance_todas': 'Todas',
  'us.estado': 'Estado',
  'us.estado_todos': 'Todos',
  'us.estado_pendiente': 'Pendiente de RR. HH.',
  'us.estado_aprobada': 'Aprobada',
  'us.estado_rechazada': 'Rechazada',
  'us.estado_cancelada': 'Cancelada',
  'us.usuario_activo': 'Activo',
  'us.usuario_inactivo': 'Inactivo',
  'us.usuario_baja': 'De baja',
  'us.vacio': 'No hay solicitudes.',
  'us.vacio_por_aprobar': 'No hay solicitudes esperando su decisión.',
  'us.col_persona': 'Persona',
  'us.col_ingreso': 'Ingreso',
  'us.col_ultimo_dia': 'Último día',
  'us.col_solicitante': 'Solicitada por',
  'us.col_fecha': 'Fecha',
  'us.col_puesto': 'Cargo',
  'us.col_acciones': 'Acciones',
  'us.baja_aplicada': 'aplicada',
  'us.baja_aplicada_el': 'Aplicada el {fecha}',
  'us.alta_ayuda': 'Este formulario crea el usuario: IT no crea usuarios a mano. El jefe directo es obligatorio.',
  'us.campo_linea': 'Línea de negocio',
  'us.campo_nombre': 'Nombre',
  'us.campo_apellido': 'Apellido',
  'us.campo_correo': 'Correo corporativo',
  'us.campo_departamento': 'Departamento',
  'us.campo_cargo': 'Cargo',
  'us.campo_jefe': 'Jefe directo',
  'us.campo_ingreso': 'Fecha de ingreso',
  'us.campo_licencias': 'Licencias',
  'us.campo_notas': 'Notas para RR. HH. e IT',
  'us.campo_persona': 'Persona',
  'us.campo_ultimo_dia': 'Último día de trabajo',
  'us.campo_razon': 'Motivo de la baja',
  'us.sin_elegir': 'Sin indicar',
  'us.elegir_jefe': 'Elija al jefe directo',
  'us.elegir_persona': 'Elija a la persona',
  'us.sin_licencias': 'No hay licencias registradas.',
  'us.sin_licencias_pedidas': 'No se pidieron licencias.',
  'us.licencia_compartida': 'Compartida: no cuesta más',
  'us.licencia_mensual': 'Mensual: {costo} por mes',
  'us.licencia_anual': 'Anual: {costo} al año',
  'us.puestos_libres': '{n} puestos libres',
  'us.costo_estimado': 'Costo estimado',
  'us.costo_compartida': 'compartida',
  'us.costo_mensual': 'mensual',
  'us.costo_puesto_libre': 'usa un puesto libre del pool',
  'us.costo_prorrateo': 'proporcional hasta la renovación',
  'us.costo_anual_completo': 'año completo',
  'us.por_mes': '{monto} por mes',
  'us.sin_costo': 'Sin costo adicional',
  'us.costo_total': 'Total: {mensual} por mes y {inicial} al ingreso',
  'us.enviar': 'Enviar a RR. HH.',
  'us.enviando': 'Enviando…',
  'us.alta_creada': 'Solicitud {codigo} enviada a RR. HH.',
  'us.baja_creada': 'Solicitud {codigo} enviada a RR. HH.',
  'us.datos_persona': 'Datos de la persona',
  'us.tareas': 'Tareas generadas',
  'us.tareas_avance': 'Tareas generadas ({hechas} de {total} terminadas)',
  'us.tareas_al_aprobar_alta': 'Al aprobarse, se generan las tareas para IT (preparar el ingreso y el equipo) y para crear cada licencia.',
  'us.tareas_al_aprobar_baja': 'Al aprobarse, se genera una tarea por cada licencia, la de recuperar el equipo y, si deja trabajo abierto, la de reasignarlo.',
  'us.sin_tareas': 'No se generaron tareas.',
  'us.vence': 'vence el {fecha}',
  'us.espera_rrhh': 'Esperando la decisión de RR. HH.',
  'us.cancelada_info': 'Quien la pidió canceló la solicitud.',
  'us.aprobo': 'Aprobada por {quien} el {fecha}.',
  'us.rechazo': 'Rechazada por {quien} el {fecha}.',
  'us.decidir': 'Su decisión',
  'us.decidir_alta_ayuda': 'Al aprobar se crea el usuario, se le envía la invitación para elegir su contraseña, se le asignan las licencias desde su ingreso y se generan las tareas.',
  'us.decidir_baja_ayuda': 'Al aprobar se generan las tareas para cerrar sus licencias y recuperar el equipo. La baja se aplica el día siguiente al último día.',
  'us.advertencia_costo': 'Costo aproximado de las licencias: {mensual} por mes y {inicial} al ingreso.',
  'us.advertencia_politica': 'Si el proceso falla después de aprobar, el cargo se factura igual.',
  'us.confirmo_costo': 'Entiendo el costo de las licencias',
  'us.advertencia_trabajo': 'La persona deja trabajo abierto: al aprobar, se genera una tarea para reasignarlo.',
  'us.motivo': 'Motivo',
  'us.motivo_ayuda': 'Para rechazar, indique el motivo.',
  'us.aprobar': 'Aprobar',
  'us.rechazar': 'Rechazar',
  'us.alta_aprobada_ok': 'Alta aprobada: se creó el usuario de {nombre} y se generaron las tareas.',
  'us.baja_aprobada_ok': 'Baja aprobada: se aplica después del {fecha}.',
  'us.rechazada_ok': 'Solicitud rechazada.',
  'us.cancelar_ayuda': 'Mientras RR. HH. no decida, puede cancelar la solicitud.',
  'us.cancelar_solicitud': 'Cancelar la solicitud',
  'us.cancelar_confirmar': '¿Cancelar la solicitud? No se puede deshacer.',
  'us.si_cancelar': 'Sí, cancelarla',
  'us.baja_ayuda_rrhh': 'Elija a la persona de la organización; el formulario se completa con sus datos y licencias.',
  'us.baja_ayuda_jefe': 'Elija a uno de sus subordinados directos; el formulario se completa con sus datos y licencias.',
  'us.sin_personas': 'No hay personas activas en esta organización.',
  'us.sin_subordinados': 'No tiene subordinados directos activos. Si necesita dar de baja a otra persona, pídaselo a RR. HH.',
  'us.ninguna': 'Ninguna',
  'us.baja_que_pasa': 'Las licencias se cierran el último día y el usuario queda de baja el día siguiente (sus sesiones se cierran).',
  'us.que_deja': 'Lo que deja',
  'us.trabajo_abierto': 'Trabajo abierto',
  'us.sin_trabajo_abierto': 'No deja trabajo abierto.',
  'us.deja_subordinados': 'Subordinados directos: {n}',
  'us.deja_tickets': 'Tickets asignados abiertos: {n}',
  'us.deja_tareas': 'Tareas abiertas: {n}',
  'us.deja_proyectos': 'Proyectos de los que es responsable: {n}',
  'us.deja_mensual': 'mensual: deja de costar',
  'us.deja_anual': 'anual: vuelve al pool',
  'us.buscar': 'Buscar',
  'us.buscar_ayuda': 'Nombre o correo',
  'us.resultados': 'Resultados',
  'us.dar_de_baja': 'Solicitar baja',
  'us.reset_mfa': 'Reset de MFA',
  'us.reset_clave': 'Reset de contraseña',
  'us.reset_mfa_confirmar': '¿Pedir a IT el reset del segundo factor (MFA) de {nombre}?',
  'us.reset_clave_confirmar': '¿Pedir a IT el reset de la contraseña de {nombre}?',
  'us.si_pedir': 'Sí, crear el ticket',
  'us.reset_ticket': 'Ticket creado para IT:',
  'us.equipo': 'Mi equipo',
  'us.equipo_descripcion': 'Las personas que le reportan directamente. Abra su ficha para ver sus datos y licencias, o pedir un cambio.',
  'us.equipo_vacio': 'No tiene personas a cargo.',
  'us.ficha_datos': 'Datos',
  'us.ficha_licencias': 'Licencias',
  'us.ficha_sin_licencias': 'No tiene licencias asignadas.',
  'us.ficha_licencias_pasadas': 'Licencias anteriores',
  'us.ficha_historial': 'Historial de cambios',
  'us.ficha_editar': 'Editar datos',
  'us.ficha_organizacion': 'Organización',
  'us.ficha_vp': 'Vicepresidente (VP)',
  'us.ficha_alta': 'Usuario desde el {fecha}',
  'us.si': 'Sí',
  'us.no': 'No',
  'us.editar_ayuda': 'Los cambios se aplican de inmediato y quedan en el historial con el valor anterior y el nuevo.',
  'us.editar_org_ayuda': 'Al cambiar de organización, elija el departamento y el jefe en la nueva. Sus licencias vigentes pasan con la persona.',
  'us.editado_ok': 'Datos actualizados.',
  'us.editado_sin_cambios': 'No había nada que cambiar.',
  'us.editado_movido': 'Datos actualizados. Cambió de organización: revise sus roles en Acceso → Usuarios (los de la organización anterior siguen vigentes, salvo "Usuario final").',
  'us.asignar_licencia': 'Asignar una licencia',
  'us.campo_licencia': 'Licencia',
  'us.elegir_licencia': 'Elija la licencia',
  'us.cambio_titulo': 'Pedir un cambio',
  'us.cambio_ayuda': 'RR. HH. o IT lo aplican: se crea un ticket para IT y RR. HH. recibe el aviso.',
  'us.cambio_que': 'Qué hay que cambiar',
  'us.cambio_jefe': 'Jefe directo',
  'us.cambio_puesto': 'Cargo o departamento',
  'us.cambio_organizacion': 'Organización',
  'us.cambio_licencias': 'Licencias (nuevas o cambios)',
  'us.cambio_datos': 'Corrección de datos',
  'us.cambio_detalle': 'Detalle del cambio',
  'us.cambio_detalle_ayuda': 'Ej.: pasa a Coordinadora de Contabilidad desde el 1/12 y necesita Adobe Acrobat.',
  'us.cambio_enviar': 'Enviar el pedido',
  'us.cambio_ok': 'Pedido enviado. Ticket para IT:',
  'us.historial_actualizado': 'Editó los datos',
  'us.historial_cambio': 'Pidió un cambio',
  'us.historial_reset_mfa': 'Pidió el reset de MFA',
  'us.historial_reset_clave': 'Pidió el reset de la contraseña',
  'us.historial_vacio': 'Sin cambios registrados.',
  'us.campo_nombre_completo': 'Nombre completo',
  'us.campo_fullName': 'Nombre',
  'us.campo_email': 'Correo',
  'us.campo_organization': 'Organización',
  'us.campo_department': 'Departamento',
  'us.campo_position': 'Cargo',
  'us.campo_manager': 'Jefe directo',
  'us.campo_isVp': 'VP',

  'li.titulo': 'Licencias',
  'li.descripcion': 'Puestos comprados, asignados y libres de cada licencia, con su costo mensual y anual. Las anuales que renuevan pronto se resaltan.',
  'li.nueva': 'Nueva licencia',
  'li.crear': 'Crear licencia',
  'li.vacio': 'No hay licencias registradas.',
  'li.total_mes': 'Costo total por mes',
  'li.total_anio': 'Costo total por año',
  'li.col_licencia': 'Licencia',
  'li.col_puestos': 'Puestos',
  'li.col_costo_puesto': 'Costo por puesto',
  'li.col_mes': 'Por mes',
  'li.col_anio': 'Por año',
  'li.col_renovacion': 'Renovación',
  'li.col_desde': 'Desde',
  'li.col_hasta': 'Hasta',
  'li.mensual': 'Mensual',
  'li.anual': 'Anual',
  'li.compartida': 'compartida',
  'li.inactiva': 'Inactiva',
  'li.administra': 'administra {nombre}',
  'li.puestos_de': '{asignados} de {total}',
  'li.puestos_sin_tope': '{asignados} (sin tope)',
  'li.disponibles': '{n} libres',
  'li.libres': 'Puestos libres',
  'li.renueva_en': 'renueva en {n} días',
  'li.resumen': 'Costo y puestos',
  'li.monto_renovacion': 'A pagar en la renovación: {monto}',
  'li.puesto_nuevo': 'Sumar un puesto hoy',
  'li.asignadas': 'Asignada a {n} personas',
  'li.sin_asignaciones': 'Nadie la tiene asignada.',
  'li.historial': 'Asignaciones anteriores',
  'li.origen_alta': 'por alta',
  'li.origen_importacion': 'importada',
  'li.editar': 'Editar',
  'li.activar': 'Activar',
  'li.desactivar': 'Desactivar',
  'li.activada_ok': 'Licencia activada.',
  'li.desactivada_ok': 'Licencia desactivada: ya no se ofrece en las altas.',
  'li.guardada_ok': 'Cambios guardados.',
  'li.solo_costos': 'Como administrador de la plataforma puede cambiar el costo, la renovación, los puestos y las notas.',
  'li.campo_nombre': 'Nombre',
  'li.campo_plataforma': 'Plataforma (Directorio de aplicaciones)',
  'li.sin_plataforma': 'Ninguna',
  'li.campo_administrador': 'Administrador de la plataforma',
  'li.campo_modalidad': 'Modalidad',
  'li.campo_costo_mes': 'Costo por puesto al mes (USD)',
  'li.campo_costo_anio': 'Costo por puesto al año (USD)',
  'li.campo_puestos': 'Puestos comprados',
  'li.campo_renovacion': 'Fecha de renovación',
  'li.campo_compartida': 'Compartida (un solo costo, sin importar cuántos la usan)',
  'li.compartida_ayuda': 'Por ejemplo, una cuenta de equipo.',
  'li.campo_notas': 'Notas',
  'li.puestos_ayuda': 'Vacío: sin tope de puestos. En una anual, el pool se paga completo en cada renovación.',
  'li.buscar_persona': 'Nombre o correo',
  'li.personas': 'Personas',
  'li.sin_personas': 'No hay personas activas que coincidan. Para alguien de otra organización, escriba su correo completo.',
  'li.cambiar': 'Cambiar',
  'li.asignar': 'Asignar a una persona',
  'li.nota': 'Nota (opcional)',
  'li.asignada_ok': 'Licencia asignada a {nombre}.',
  'li.asignada_extra_ok': 'Licencia asignada a {nombre}: se compró un puesto más.',
  'li.costo_puesto_extra': 'Costo del puesto adicional hasta la renovación: {monto}',
  'li.comprar_puesto': 'Comprar un puesto y asignarla',
  'li.liberar': 'Liberar',
  'li.ultimo_dia': 'Último día',
  'li.termina_el': 'Termina el {fecha}',
  'li.importar': 'Importar asignaciones',
  'li.importar_abrir': 'Importar asignaciones desde un CSV',
  'li.importar_ayuda': 'Una línea por asignación: correo;licencia;desde (la fecha es opcional: hoy). Si una línea tiene un error no se importa nada; las que ya existen se saltan.',
  'li.importar_archivo': 'Archivo CSV de asignaciones',
  'li.importar_ok': 'Listo: {creadas} asignaciones creadas y {saltadas} que ya existían.',

  'pv.titulo': 'Proveedores',
  'pv.descripcion': 'Los mantiene IT; Finanzas y Contabilidad los consultan para registrarlos en Sage. Cada cambio queda en el historial, con los datos bancarios resaltados.',
  'pv.nuevo': 'Nuevo proveedor',
  'pv.crear': 'Crear proveedor',
  'pv.vacio': 'No hay proveedores que coincidan.',
  'pv.buscar_ayuda': 'Nombre, razón social o RUC/RUT',
  'pv.ver_inactivos': 'Incluir los inactivos',
  'pv.col_proveedor': 'Proveedor',
  'pv.activo': 'Activo',
  'pv.inactivo': 'Inactivo',
  'pv.generales': 'Datos generales',
  'pv.contacto': 'Contacto',
  'pv.bancarios': 'Datos bancarios',
  'pv.bancarios_ayuda': 'Cada cambio en estos datos queda registrado con quién lo hizo y cuándo.',
  'pv.campo_tradeName': 'Nombre comercial',
  'pv.campo_legalName': 'Razón social',
  'pv.campo_taxId': 'RUC/RUT',
  'pv.campo_country': 'País (2 letras)',
  'pv.campo_address': 'Dirección',
  'pv.campo_contactName': 'Persona de contacto',
  'pv.campo_email': 'Correo',
  'pv.campo_phone': 'Teléfono',
  'pv.campo_bankName': 'Banco',
  'pv.campo_bankAccount': 'Número de cuenta',
  'pv.campo_bankAccountType': 'Tipo de cuenta',
  'pv.campo_bankAccountHolder': 'Titular de la cuenta',
  'pv.campo_notes': 'Notas',
  'pv.campo_active': 'Estado',
  'pv.titular_ayuda': 'Si no es la razón social',
  'pv.cuenta_corriente': 'Corriente',
  'pv.cuenta_ahorros': 'Ahorros',
  'pv.creado_ok': 'Proveedor creado.',
  'pv.guardado_ok': 'Cambios guardados.',
  'pv.activado_ok': 'Proveedor activado.',
  'pv.desactivado_ok': 'Proveedor desactivado: ya no aparece en la lista.',
  'pv.editar': 'Editar',
  'pv.activar': 'Activar',
  'pv.desactivar': 'Desactivar',
  'pv.creado_por': 'Creado por {quien} el {fecha}',
  'pv.editado_por': 'editado por {quien} el {fecha}',
  'pv.historial': 'Historial de cambios',
  'pv.h_creado': '{quien} creó el proveedor',
  'pv.h_actualizado': '{quien} editó el proveedor',
  'pv.h_bancarios': '{quien} cambió los datos bancarios',

  'inv.titulo': 'Inventario',
  'inv.descripcion': 'Los equipos con su agente: si está en línea, su versión y su último inventario. Los equipos nuevos quedan por revisar.',
  'inv.secciones': 'Secciones de Inventario',
  'inv.equipos': 'Equipos',
  'inv.enrolamiento': 'Enrolamiento',
  'inv.enrolamiento_descripcion': 'Tokens para instalar el agente: uno por organización u oleada de despliegue, con vencimiento y tope de usos. Se revoca al terminar.',
  'inv.buscar': 'Buscar',
  'inv.buscar_ayuda': 'Nombre, serie o modelo',
  'inv.estado': 'Estado',
  'inv.estado_todos': 'Todos',
  'inv.estado_activo': 'Activo',
  'inv.estado_por_revisar': 'Por revisar',
  'inv.estado_retirado': 'Retirado',
  'inv.vacio': 'No hay equipos que coincidan.',
  'inv.ver_todos': 'Ver todos los equipos',
  'inv.hay_por_revisar': 'Hay {n} equipos por revisar: se enrolaron, pero IT tiene que confirmarlos.',
  'inv.sin_nombre': 'Equipo sin nombre',
  'inv.motivo_serie_desconocida': 'Serie fuera del inventario importado',
  'inv.motivo_serie_generica': 'Serie genérica: no sirve para identificarlo',
  'inv.motivo_cambio_organizacion': 'Se enroló con un token de otra organización',
  'inv.motivo_hardware_duplicado': 'Otro equipo tiene el mismo identificador de hardware',
  'inv.pide_pasar': 'pide pasar a {org}',
  'inv.en_linea': 'En línea',
  'inv.desconectado_desde': 'Desconectado desde el {fecha}',
  'inv.sin_latido': 'Sin latidos todavía',
  'inv.agente_version': 'agente {v}',
  'inv.ultimo_inventario': 'Inventario del {fecha}',
  'inv.sin_agente': 'Sin agente',
  'inv.sin_agente_importado': 'Importado, sin agente todavía',
  'inv.aprobar': 'Aprobar el equipo',
  'inv.confirmar_cambio': 'Pasarlo a {org}',
  'inv.rechazar_cambio': 'Dejarlo donde está',
  'inv.revocar_agente': 'Revocar el agente',
  'inv.motivo_revocar': 'Motivo',
  'inv.si_revocar': 'Revocar',
  'inv.revocar_ayuda': 'El agente deja de reportar de inmediato. Para volver a conectarlo hay que reinstalarlo con un token nuevo.',
  'inv.nuevo_token': 'Nuevo token',
  'inv.organizacion': 'Organización',
  'inv.etiqueta': 'Para qué es',
  'inv.etiqueta_ayuda': 'Ej. "Oleada 1, oficina Panamá"',
  'inv.tope_usos': 'Cantidad máxima de equipos',
  'inv.token_ayuda': 'Vence en {dias} días. Un equipo cuya serie no está en el inventario importado queda por revisar.',
  'inv.crear_token': 'Crear token',
  'inv.token_creado': 'Copie el token ahora: no se vuelve a mostrar. Va en el script de instalación y nunca en el repositorio.',
  'inv.copiar': 'Copiar',
  'inv.copiado': 'Copiado',
  'inv.ya_lo_guarde': 'Ya lo guardé',
  'inv.sin_tokens': 'Todavía no hay tokens.',
  'inv.col_token': 'Token',
  'inv.col_usos': 'Equipos',
  'inv.col_vence': 'Vence',
  'inv.usos_de': '{usos} de {tope}',
  'inv.token_vigente': 'Vigente',
  'inv.token_vencido': 'Vencido',
  'inv.token_agotado': 'Agotado',
  'inv.token_revocado': 'Revocado',
  'inv.revocar': 'Revocar',

  'kb.titulo': 'Base de conocimientos',
  'kb.descripcion': 'Guías para resolver lo más común por su cuenta y procedimientos de IT.',
  'kb.nuevo': 'Nuevo artículo',
  'kb.buscar': 'Buscar',
  'kb.buscar_ayuda': 'Qué necesita: "cambiar contraseña", "VPN", "impresora"…',
  'kb.estado': 'Estado',
  'kb.estado_publicado': 'Publicado',
  'kb.estado_borrador': 'Borrador',
  'kb.estado_archivado': 'Archivado',
  'kb.estado_publicado_plural': 'Publicados',
  'kb.estado_borrador_plural': 'Borradores',
  'kb.estado_archivado_plural': 'Archivados',
  'kb.categorias': 'Categorías',
  'kb.todas': 'Todas',
  'kb.resultados': 'Artículos',
  'kb.sin_resultados': 'No hay guías para «{texto}».',
  'kb.vacio': 'Todavía no hay artículos aquí.',
  'kb.no_encuentra': '¿No encuentra lo que busca?',
  'kb.abrir_ticket': 'Abrir un ticket',
  'kb.buscar_en_tickets': 'Buscar en mis tickets',
  'kb.solo_it': 'Solo IT',
  'kb.actualizado': 'Actualizado el {fecha}',
  'kb.etiquetas': 'Etiquetas',
  'kb.no_sirvio': '¿La guía no le resolvió el problema? Cuéntenos qué pasa y lo atendemos.',
  'kb.adjuntos_ayuda': 'Capturas, manuales en PDF o plantillas que acompañan la guía.',
  'kb.datos': 'Datos',
  'kb.version': 'Versión',
  'kb.vistas': 'Lecturas',
  'kb.en_tickets': 'Usado en tickets',
  'kb.creado_por': 'Creado por',
  'kb.editado_por': 'Última edición',
  'kb.editar': 'Editar',
  'kb.publicar': 'Publicar',
  'kb.despublicar': 'Volver a borrador',
  'kb.archivar': 'Archivar',
  'kb.cambiado_publicado': 'Artículo publicado.',
  'kb.cambiado_borrador': 'El artículo volvió a borrador: ya no lo ven los colaboradores.',
  'kb.cambiado_archivado': 'Artículo archivado.',
  'kb.historial': 'Historial',
  'kb.version_actual': 'Versión {v} (actual)',
  'kb.version_n': 'Versión {v}',
  'kb.volver_actual': 'Volver a la versión actual',
  'kb.version_vieja': 'Está viendo la versión {v}, guardada el {fecha}. No es la vigente.',
  'kb.editar_titulo': 'Editar {code}',
  'kb.campo_titulo': 'Título',
  'kb.campo_resumen': 'Resumen',
  'kb.campo_resumen_ayuda': 'Una o dos líneas: es lo que se ve en la búsqueda.',
  'kb.campo_cuerpo': 'Contenido',
  'kb.modo': 'Escribir o ver cómo queda',
  'kb.escribir': 'Escribir',
  'kb.vista_previa': 'Vista previa',
  'kb.vista_vacia': 'Aquí verá cómo queda el artículo.',
  'kb.markdown_ayuda': 'Markdown: ## Título, **negrita**, - lista, 1. pasos, [enlace](https://…), `código`. Las capturas van como adjuntos.',
  'kb.campo_audiencia': 'Quién lo ve',
  'kb.audiencia_todos': 'Todos',
  'kb.audiencia_todos_ayuda': 'Guía de autoservicio para los colaboradores.',
  'kb.audiencia_it': 'Solo IT',
  'kb.audiencia_it_ayuda': 'Procedimiento o solución interna.',
  'kb.campo_categoria': 'Categoría',
  'kb.sin_categoria': 'Sin categoría',
  'kb.campo_aplicacion': 'Aplicación',
  'kb.sin_aplicacion': 'Ninguna en particular',
  'kb.campo_etiquetas': 'Etiquetas',
  'kb.campo_etiquetas_ayuda': 'Separadas por comas: correo, outlook, móvil',
  'kb.adjuntos_despues': 'Los adjuntos se agregan después de guardar.',
  'kb.guardar_borrador': 'Guardar borrador',
  'kb.guardar_cambios': 'Guardar cambios',
  'kb.editar_publicado': 'El artículo está publicado: los cambios se ven apenas los guarde.',
  'kb.guardado': 'Cambios guardados.',
  'kb.creado_publicado': 'Artículo publicado.',
  'kb.creado_borrador': 'Borrador guardado. Publíquelo cuando esté listo.',
  'kb.sugeridos': 'Quizá esto le sirva',
  'kb.insertar': 'Insertar artículo',
  'kb.insertar_buscar': 'Buscar un artículo para insertar',
  'kb.insertar_vacio': 'No hay artículos con ese texto.',
  'kb.usados': 'Artículos usados',

  'mon.titulo': 'Monitoreo',
  'mon.descripcion': 'Qué sitios y aplicaciones están arriba, cómo está el servidor y qué pasó. Se revisa cada minuto; las caídas avisan por correo y en la campana.',
  'mon.secciones': 'Secciones de Monitoreo',
  'mon.estado': 'Estado',
  'mon.servidor': 'Servidor',
  'mon.incidentes': 'Incidentes',
  'mon.mantenimientos': 'Mantenimientos',
  'mon.hay_caidos': 'No responde ahora: {nombres}.',
  'mon.todo_arriba': 'Todos los sitios activos responden.',
  'mon.hay_por_revisar': 'Sitios nuevos por revisar: {n}. Vienen de CloudPanel o del Directorio y esperan que IT decida si se vigilan.',
  'mon.ver_por_revisar': 'Revisarlos',
  'mon.cuenta_arriba': 'Arriba',
  'mon.cuenta_lento': 'Lentos',
  'mon.cuenta_caido': 'Caídos',
  'mon.cuenta_desconocido': 'Sin datos aún',
  'mon.estado_arriba': 'Arriba',
  'mon.estado_lento': 'Lento',
  'mon.estado_caido': 'Caído',
  'mon.estado_desconocido': 'Sin datos',
  'mon.estado_pausado': 'Pausado',
  'mon.estado_por_revisar': 'Por revisar',
  'mon.filtro': 'Mostrar',
  'mon.filtro_activos': 'Vigilados',
  'mon.filtro_por_revisar': 'Por revisar',
  'mon.filtro_pausados': 'Pausados',
  'mon.filtro_todos': 'Todos',
  'mon.buscar': 'Buscar',
  'mon.buscar_ayuda': 'Nombre o dirección',
  'mon.sitios': 'Sitios y aplicaciones',
  'mon.vacio': 'No hay sitios en esta lista.',
  'mon.vacio_inicio': 'Todavía no hay sitios vigilados. Agregue uno, o espere a que el worker traiga los de CloudPanel y del Directorio (cada hora).',
  'mon.col_sitio': 'Sitio',
  'mon.col_estado': 'Estado',
  'mon.col_24h': '24 h',
  'mon.col_7d': '7 días',
  'mon.col_30d': '30 días',
  'mon.col_latencia': 'Respuesta',
  'mon.col_certificado': 'Certificado',
  'mon.disponibilidad': 'Disponibilidad',
  'mon.sin_datos': '—',
  'mon.ms': '{n} ms',
  'mon.cert_dias': '{n} días',
  'mon.cert_vencido': 'Vencido',
  'mon.desde': 'desde {fecha}',
  'mon.revisado': 'Revisado {fecha}',
  'mon.ya_no_esta': 'Ya no aparece en {origen}',
  'mon.origen_manual': 'Agregado a mano',
  'mon.origen_cloudpanel': 'CloudPanel',
  'mon.origen_directorio': 'Directorio de aplicaciones',
  'mon.seleccionar': 'Seleccionar {nombre}',
  'mon.seleccionar_todos': 'Seleccionar todos',
  'mon.activar_seleccion': 'Vigilar los seleccionados ({n})',
  'mon.no_vigilar_seleccion': 'No vigilar los seleccionados ({n})',
  'mon.no_vigilar_ayuda': 'Pasan a «Pausados»: salen de la lista por revisar y no se vuelven a proponer. Se pueden vigilar más adelante desde su ficha.',
  'mon.no_vigilados': 'Listo: sitios que no se vigilan ({n}). Quedan en «Pausados» por si alguno se necesita más adelante.',
  'mon.activados': 'Listo: sitios activados ({n}). Se revisan desde el próximo minuto.',
  'mon.agregar': 'Agregar sitio',
  'mon.nuevo_titulo': 'Nuevo sitio',
  'mon.campo_nombre': 'Nombre',
  'mon.campo_url': 'Dirección',
  'mon.campo_url_ayuda': 'La página que se revisa, ej. https://sit365.gruposiuma.com/api/salud',
  'mon.campo_app': 'Aplicación del Directorio',
  'mon.campo_app_ninguna': 'Ninguna',
  'mon.campo_responsable': 'Responsable (recibe las alertas)',
  'mon.campo_responsable_ninguno': 'El de la aplicación, o solo IT',
  'mon.campo_codigos': 'Códigos HTTP que cuentan como arriba',
  'mon.campo_codigo_min': 'Desde',
  'mon.campo_codigo_max': 'Hasta',
  'mon.campo_texto': 'Texto que debe aparecer (opcional)',
  'mon.campo_texto_ayuda': 'Detecta una página de error que igual responde 200. Ej. el nombre de la aplicación.',
  'mon.crear': 'Agregar y vigilar',
  'mon.creado': 'Sitio agregado: se revisa en el próximo minuto.',
  'mon.servidor_resumen': 'Servidor',
  'mon.servidor_sin_datos': 'El servidor dejó de reportar: revise que el worker esté en línea (pm2 status).',
  'mon.ver_servidor': 'Ver el servidor',
  'mon.cpu': 'CPU',
  'mon.memoria': 'Memoria',
  'mon.swap': 'Swap',
  'mon.disco': 'Disco',
  'mon.carga': 'Carga (1 min)',
  'mon.libres': '{gb} libres',
  'mon.de_total': 'de {gb}',
  'mon.ultimas_24h': 'Últimas 24 h',
  'mon.periodo': 'Período',
  'mon.periodo_24h': '24 horas',
  'mon.periodo_7d': '7 días',
  'mon.periodo_30d': '30 días',
  'mon.latencia': 'Tiempo de respuesta',
  'mon.latencia_ayuda': 'Promedio de las revisiones que respondieron bien.',
  'mon.uptime_dias': 'Disponibilidad por día (últimos 30 días)',
  'mon.leyenda_bien': '99,9 % o más',
  'mon.leyenda_regular': '99 % a 99,9 %',
  'mon.leyenda_mal': 'Menos de 99 %',
  'mon.leyenda_sin': 'Sin revisiones',
  'mon.dia_tooltip': '{dia}: {valor}',
  'mon.tabla_datos': 'Ver los datos en una tabla',
  'mon.col_momento': 'Momento',
  'mon.col_valor': 'Valor',
  'mon.sin_puntos': 'Todavía no hay datos para este período.',
  'mon.ultima_revision': 'Última revisión',
  'mon.codigo': 'Código HTTP',
  'mon.ultimo_error': 'Último error',
  'mon.emisor': 'Emisor del certificado',
  'mon.vence': 'Vence el {fecha}',
  'mon.responsable': 'Responsable',
  'mon.responsable_app': '{nombre} (de la aplicación)',
  'mon.solo_it': 'Solo quienes reciben las alertas de IT',
  'mon.aplicacion': 'Aplicación',
  'mon.origen': 'Origen',
  'mon.pausar': 'Pausar',
  'mon.vigilar': 'Vigilar',
  'mon.revisar_ahora': 'Revisar ahora',
  'mon.revisar_pedido': 'Se revisará en el próximo minuto.',
  'mon.editar': 'Editar',
  'mon.guardado': 'Cambios guardados.',
  'mon.pausar_ayuda': 'Un sitio pausado no se revisa ni avisa, y sus incidentes abiertos se cierran.',
  'mon.configuracion': 'Configuración',
  'mon.inc_vacio': 'No hubo incidentes.',
  'mon.inc_abiertos': 'Abiertos',
  'mon.inc_todos': 'Últimos 200',
  'mon.inc_abierto': 'En curso',
  'mon.inc_cerrado': 'Resuelto',
  'mon.inc_duracion': 'Duró {d}',
  'mon.inc_lleva': 'Lleva {d}',
  'mon.inc_tomado': '{nombre} lo está viendo',
  'mon.inc_tomar': 'Lo estoy viendo',
  'mon.inc_tomar_ayuda': 'Deja constancia de que alguien lo atiende y detiene los recordatorios.',
  'mon.inc_avisos': 'avisos enviados: {n}',
  'mon.tipo_caida': 'Caída',
  'mon.tipo_certificado': 'Certificado',
  'mon.tipo_cpu': 'CPU',
  'mon.tipo_memoria': 'Memoria',
  'mon.tipo_swap': 'Swap',
  'mon.tipo_disco': 'Disco',
  'mon.tipo_respaldo': 'Respaldo',
  'mon.tipo_cola_correo': 'Correo',
  'mon.mant_descripcion': 'Mientras dura un mantenimiento no se abren incidentes ni cuenta en la disponibilidad. Úselo para reinicios, despliegues o cortes programados.',
  'mon.mant_nuevo': 'Programar mantenimiento',
  'mon.mant_sitio': 'Qué',
  'mon.mant_todo': 'Todos los sitios y el servidor',
  'mon.mant_inicio': 'Inicio',
  'mon.mant_fin': 'Fin',
  'mon.mant_motivo': 'Motivo',
  'mon.mant_motivo_ayuda': 'Ej. "Actualización de Node en el VPS"',
  'mon.mant_crear': 'Programar',
  'mon.mant_vacio': 'No hay mantenimientos en curso ni programados.',
  'mon.mant_programado': 'Programado',
  'mon.mant_en_curso': 'En curso',
  'mon.mant_terminado': 'Terminado',
  'mon.mant_terminar': 'Terminar ahora',
  'mon.mant_cancelar': 'Cancelar',
  'mon.mant_en_curso_aviso': 'Mantenimiento en curso: {lista}.',
  'mon.mant_por': 'por {nombre}',
  'mon.host_info': '{cpus} CPU · {ram} de memoria · {os}',
  'mon.encendido': 'Encendido desde {fecha}',
  'mon.postgres': 'Conexiones a PostgreSQL',
  'mon.base': 'Tamaño de la base',
  'mon.cola': 'Cola de correo',
  'mon.cola_detalle': '{esperando} esperando · {reintentos} en reintento · {fallidos} fallidos',
  'mon.respaldo': 'Último respaldo en la nube',
  'mon.respaldo_hace': 'hace {h} h',
  'mon.respaldo_sin': 'Sin registro',
  'mon.sin_servidor': 'Este tenant no administra el servidor: aquí solo se ven sus sitios.',
  'mon.umbral': 'Umbral {n} %',

  'modulo.monitoreo': 'Monitoreo',
  'modulo.tickets': 'Tickets',
  'modulo.proyectos': 'Proyectos y tareas',
  'modulo.usuarios': 'Usuarios',
  'modulo.licencias': 'Licencias',
  'modulo.proveedores': 'Proveedores',
  'modulo.conocimiento': 'Base de conocimientos',
  'modulo.directorio': 'Directorio de aplicaciones',
  'modulo.plataforma': 'Plataforma',
  'modulo.inventario': 'Inventario',
  'modulo.remoto': 'Acceso remoto',
  'modulo.software': 'Software',
  'modulo.politicas': 'Políticas',

  'error.no_encontrado': 'La página no existe.',
} as const;

export type MessageKey = keyof typeof es;
